/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

export function OrderForm({
  id,
  moduleValues,
  setModuleValues
}) {
  const [order, setOrder] = useState(0);

  useEffect(() => {
    const thisValue = moduleValues ? moduleValues.find(value => value.id === id) : undefined;
    const order = thisValue ? thisValue.order : "";
    setOrder(order);
  }, [id, moduleValues]);

  return (
    <Form.Control
      type="number"
      value={order}
      min={1}
      placeholder="Sıra"
      onChange={e => {
        const otherValues = moduleValues.filter(value => value.id !== id);
        otherValues.push({ id, order: e.target.value });
        setModuleValues(otherValues);
      }}
    />
  )
}